module.exports = __webpack_public_path__ + "boxed-bg.jpg";